<template>
  <div class="echart" :id="'echart'+index">
  </div>
</template>

<script>
  import Vue from 'vue'
  import echarts from 'echarts'

  export default ({
    /*
    * index: 图标ID，避免绘图时冲突
    * curData: 当前图标数据
    * chartData: 所有图标数据，用于遍历
    * */
    props: ['index', 'xData', 'yData'],
    data() {
      return {
        //dataNum: 5,    // 定义图表中显示的数据个数
      }
    },
    mounted() {
      this.showCharts();
    },
    // 销毁子组件后重建，避免第一个数据不更新的问题
    // destroyed() {
    //   this.$parent.showChart = true;
    // },
    methods: {
      showCharts: function() {
        var options = {
          title: {
            x: 'center'
          },
          tooltip: {
            trigger: 'axis'
          },
          // 显示折线的名称
          // legend: {
          //   data:['次数']
          // },
          xAxis: {
            // name: '日期',
            nameTextStyle: {
              color: '#444'
            },
            axisLine: {
              lineStyle: {
                color: '#eee'
              }
            },
            axisLabel: {
              textStyle: {
                color: '#444'
              }
            },
            // 从y轴开始显示
            boundaryGap : false,
            data: this.xData
          },
          yAxis: {
            // name: '次数',
            nameTextStyle: {
              color: '#444'
            },
            axisLine: {
              lineStyle: {
                color: '#eee'
              }
            },
            //max: 1400,
            interval: 5,
            axisLabel: {
              textStyle: {
                color: '#444'
              }
            },
            splitLine: {
              lineStyle: false
            }
          },
          series: [{
            // name: ['次数'],
            type: 'line',
            itemStyle: {
              normal: {
                // 填充区域颜色
                areaStyle: {
                  type: 'default',
                  color:'#CDE5FA'
                },
                // 曲线颜色
                lineStyle: {
                  color: '#0a81e5'
                },
                // 标注颜色
                color: '#0a81e5'
              }
            },
            // 折线平滑展示
            smooth: true,
            data: this.yData
          }]
        };
        // 基于准备好的dom，初始化echarts实例
        var chartID = 'echart'+this.index;
        var myChart = echarts.init(document.getElementById(chartID));
        myChart.setOption(options);
      }
    }
  })
</script>

<style scoped>
  .echart{
    width: 100%!important;
    height: 248px!important;
  }
  @media (-webkit-max-width: 1024px),(max-width:1024px){
    .echart{
      width:600px!important;
      height:200px!important;
    }
    .echart div{
      width:600px!important;
      height:200px!important;
    }
    .echart canvas{
      width:626px !important;
      height:220px !important;
      left:26px !important;
      top:20px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// digEchart.vue?1fdaa0bb